import React, { useState, useEffect } from "react";
import { ModalComp, KeyLamp, Schedule, Camera, ThreeWay } from "../";
import {
  WidgetCommands,
  ScheduleList,
  WidgetSetting,
  EditWidget,
  MoveWidget,
  InfoWidget,
  DeviceInfo,
  LearnWidget,
} from "./";

import { useTranslation } from "react-i18next";
import { FaEyeSlash, FaEye, FaQuestion } from "react-icons/fa";

const OnOffWidget = ({
  zone,
  isPhone,
  show,
  sendWidgetCommand,
  health,
  showAll,
  setShowFreezing,
}) => {
  const { t } = useTranslation();
  const [openKeyLampModal, setOpenKeyLampModal] = useState(false);
  const toggleKeyLamp = () => setOpenKeyLampModal(!openKeyLampModal);
  const openKeyLamp = () => {
    if (isPhone && window.orientation === 0) {
      toggleKeyLamp();
    } else {
      show("threeWay");
    }
  };
  const [widgetSettingOpen, setWidgetSettingOpen] = useState(false);
  const toggleWidgetSetting = () => setWidgetSettingOpen(!widgetSettingOpen);
  const [openCommandsModal, setOpenCommandsModal] = useState(false);
  const toggleCommands = () => setOpenCommandsModal(!openCommandsModal);
  const [openEditModal, setOpenEditModal] = useState(false);
  const toggleEdit = () => setOpenEditModal(!openEditModal);
  const [openMoveModal, setOpenMoveModal] = useState(false);
  const toggleMove = () => setOpenMoveModal(!openMoveModal);
  const [openScheduleListModal, setOpenScheduleListModal] = useState(false);
  const toggleScheduleList = () =>
    setOpenScheduleListModal(!openScheduleListModal);
  const [commandSending, setCommandSending] = useState(false);
  const [openInfoModal, setOpenInfoModal] = useState(false);
  const toggleInfo = () => setOpenInfoModal(!openInfoModal);
  const [openDeviceInfoModal, setOpenDeviceInfoModal] = useState(false);
  const toggleDeviceInfo = () => setOpenDeviceInfoModal(!openDeviceInfoModal);
  const [openLearnModal, setOpenLearnModal] = useState(false);
  const toggleLearn = () => setOpenLearnModal(!openLearnModal);
  
  // State for power color class
  const [powerColorClass, setPowerColorClass] = useState("");

  useEffect(() => {
    var elem = document.getElementById(
      `${zone.uid}index${zone.index}`
    )?.classList;
    var element = document.getElementById(`${zone.uid}index${zone.index}`);
    if (elem && elem[3] === "device-on") {
      element?.classList.remove("device-on");
      element?.classList.add("device-off");
    }

    var sp = document.getElementById(`${zone.uid}span${zone.index}`)?.classList;
    var span = document.getElementById(`${zone.uid}span${zone.index}`);
    if (sp && sp[9] === "successBorder") {
      span?.classList.remove("successBorder");
      span?.classList.add("dangerBorder");
    }
  }, [zone]);

  // Effect to watch for power color changes from MQTT
  useEffect(() => {
    const checkPowerColor = () => {
      const element = document.getElementById(`${zone.uid}index${zone.index}`);
      if (!element) return;
      
      // Check if element has any power color class
      if (element.classList.contains('widget-power-low')) {
        setPowerColorClass('widget-power-low');
      } else if (element.classList.contains('widget-power-medium')) {
        setPowerColorClass('widget-power-medium');
      } else if (element.classList.contains('widget-power-high')) {
        setPowerColorClass('widget-power-high');
      } else if (element.classList.contains('device-on')) {
        setPowerColorClass('widget-power-low'); // default green for on without power data
      } else {
        setPowerColorClass('');
      }
    };
    
    checkPowerColor();
    
    // Set up an observer to watch for class changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          checkPowerColor();
        }
      });
    });
    
    const element = document.getElementById(`${zone.uid}index${zone.index}`);
    if (element) {
      observer.observe(element, { attributes: true });
    }
    
    return () => observer.disconnect();
  }, [zone.uid, zone.index]);

  const sendCommand = () => {
    var sp = document.getElementById(`${zone.uid}span${zone.index}`)?.classList;
    if (sp && sp[9] === "successBorder") {
      setShowFreezing(true);
      setCommandSending(true);
      if (zone.property[0] === "Widget3") {
        sendWidgetCommand(zone.commands[0]["command"], zone.uid);
      } else {
        if (zone.property[4] === "Conf1") {
          var elem = document.getElementById(
            `${zone.uid}index${zone.index}`
          )?.classList;
          if (elem && elem[3] === "device-on") {
            sendWidgetCommand(zone.commands[1]["command"], zone.uid);
          } else if (elem && elem[3] === "device-off") {
            sendWidgetCommand(zone.commands[0]["command"], zone.uid);
          }
        } else {
          sendWidgetCommand(zone.commands[2]["command"], zone.uid);
        }
      }
      setTimeout(() => {
        setShowFreezing(false);
      }, 1000);
    }
  };

  // Determine the final className for the device div
  const getDeviceClassName = () => {
    let className = "device w-100 p-3";
    
    // Check if element has device-on or device-off from DOM
    const element = document.getElementById(`${zone.uid}index${zone.index}`);
    const isDeviceOn = element?.classList.contains('device-on');
    
    if (isDeviceOn) {
      className += " device-on";
    } else {
      className += " device-off";
    }
    
    // Add power color class if device is on
    if (isDeviceOn && powerColorClass) {
      className += ` ${powerColorClass}`;
    }
    
    return className;
  };

  return (
    <>
      <ModalComp
        modal={openKeyLampModal}
        toggle={toggleKeyLamp}
        component={<Camera />}
      />
      <ModalComp
        modal={openCommandsModal}
        toggle={toggleCommands}
        component={<WidgetCommands zone={zone} />}
      />
      <ModalComp
        modal={openScheduleListModal}
        toggle={toggleScheduleList}
        component={<ScheduleList zone={zone} />}
      />
      <ModalComp
        modal={openEditModal}
        toggle={toggleEdit}
        component={<EditWidget zone={zone} toggleEdit={toggleEdit} />}
      />
      <ModalComp
        modal={openInfoModal}
        toggle={toggleInfo}
        component={<InfoWidget zone={zone} toggleInfo={toggleInfo} />}
      />
      <ModalComp
        modal={openLearnModal}
        toggle={toggleLearn}
        component={<LearnWidget zone={zone} toggleLearn={toggleLearn} />}
      />
      <ModalComp
        modal={openDeviceInfoModal}
        toggle={toggleDeviceInfo}
        component={<DeviceInfo toggleDeviceInfo={toggleDeviceInfo} />}
      />
      <ModalComp
        modal={openMoveModal}
        toggle={toggleMove}
        component={<MoveWidget zone={zone} toggleMove={toggleMove} />}
      />
      <ModalComp
        modal={widgetSettingOpen}
        toggle={toggleWidgetSetting}
        component={
          <WidgetSetting
            zone={zone}
            toggleCommands={toggleCommands}
            toggleScheduleList={toggleScheduleList}
            toggleEdit={toggleEdit}
            toggleInfo={toggleInfo}
            toggleLearn={toggleLearn}
            toggleDeviceInfo={toggleDeviceInfo}
            toggleMove={toggleMove}
          />
        }
        dark={true}
      />
      <div>
        <div 
          className={getDeviceClassName()} 
          id={`${zone.uid}index${zone.index}`}
        >
          <div className="d-flex align-items-center justify-content-between position-relative">
            <i
              onClick={sendCommand}
              id={`${zone.uid}span${zone.index}`}
              className={`deviceCircle dangerBorder d-flex cursor align-items-center justify-content-center text-center 
                            ${
                              (zone.uid === health.serial &&
                                health.health[zone.index] === 1) ||
                              health.health[zone.index] === 2
                                ? "bg-activeDevice text-white"
                                : "bg-deactiveDevice text-dark"
                            } ${zone.uid}`}
            >
              {zone.property[2] !== "image_path" ? (
                <img src={zone.property[2]} className="w-75" alt="device" />
              ) : (
                <FaQuestion />
              )}
            </i>
            {showAll && zone.property[3] === "0" ? (
              <FaEyeSlash />
            ) : showAll && zone.property[3] === "1" ? (
              <FaEye />
            ) : (
              ""
            )}
          </div>
          <div className="fn widgets pt-2">
            <b className="m-0 fn12" onClick={openKeyLamp}>
              {zone.caption}
            </b>
          </div>
          {zone.property[4] === "Conf2" ? (
            <small className="fn10 d-block pb-1 pt-2">{t("تحریک")}</small>
          ) : (
            <small
              id={`${zone.uid}text${zone.index}`}
              className="fn10 d-block pb-1 pt-2"
            >
              {t("خاموش")}
            </small>
          )}
          <div>
            <i
              className="icon-ellipsis-vert p-1 detailIconRotate cursor"
              onClick={toggleWidgetSetting}
            ></i>
          </div>
        </div>
      </div>
    </>
  );
};

export { OnOffWidget };